// Swedish labels for tool activity and approval cards. Unknown tools fall back to their raw name.

// Keys are toolbox connection names (toolbox/salesm8-agent-tools.yaml) and short aliases.
const SERVERS: Record<string, string> = {
  kundplan: "Kundplan",
  "salesm8-kundplan": "Kundplan",
  "salesm8-m365-copilot": "Copilot-sök",
  "salesm8-m365-mail": "Outlook",
  "salesm8-m365-calendar": "Kalender",
  "salesm8-m365-teams": "Teams",
  "salesm8-m365-sharepoint": "SharePoint",
  "salesm8-m365-onedrive": "OneDrive",
  "salesm8-dataverse": "Dynamics 365",
  workiq: "Work IQ",
  d365sales: "Dynamics 365",
};

const TOOLS: Record<string, string> = {
  get_reference_data: "Hämtar referensdata",
  summarize_plans: "Summerar kundplaner",
  list_plans: "Söker kundplaner",
  get_plan: "Läser kundplanen",
  find_offering_status: "Kollar erbjudanden",
  search_plan_text: "Söker i plantexter",
  create_plan: "Skapa kundplan",
  update_plan_overview: "Uppdatera planöversikten",
  update_plan_area: "Uppdatera affärsområde",
  set_offering_status: "Sätt status på erbjudande",
};

const baseName = (name: string) => name.split(/\.|__|\//).at(-1) ?? name;

export function serverLabel(server: string, name = ""): string {
  if (SERVERS[server]) return SERVERS[server];
  if (/work.?iq|m365/i.test(server + name)) return "Microsoft 365";
  if (/d365|dynamics|dataverse/i.test(server + name)) return "Dynamics 365";
  if (TOOLS[baseName(name)]) return "Kundplan";
  return server || "Verktyg";
}

export function toolLabel(name: string): string {
  return TOOLS[baseName(name)] ?? baseName(name).replace(/_/g, " ");
}

export const ARG_LABELS: Record<string, string> = {
  planId: "Plan",
  businessAreaId: "Affärsområde",
  offeringId: "Erbjudande",
  accountId: "Kund",
  newCustomerName: "Ny kund",
  expectedRevision: "Revision",
  status: "Status",
  segment: "Segment",
  existingAnnualBusiness: "Befintlig årlig affär (kr)",
  newAnnualBusiness: "Ny årlig affär (kr)",
  text: "Text",
  plan: "Plantext",
  currentState: "Nuläge",
  targetState: "Målbild",
  accountManagerVision: "Account Manager-vision",
  comment: "Kommentar",
  mode: "Läge",
};
